export const validateLocale = (locale = "nl") => {
    return locale === "en" ? "en" : "nl";
}
